define('home/views/SettingsEmailView',[
    'jquery',
    'underscore',

    'home/models/SettingsEmailNotifications',
    'home/templates/settingsEmail',
    'home/views/common/BaseSettingsView',
], function (
    $,
    _,

    SettingsEmailNotifications,
    settingsEmailTemplate,
    BaseSettingsView
) {
    'use strict';

    var SettingsEmailView = BaseSettingsView.extend({
        template: settingsEmailTemplate,

        events: _.defaults({
            'change input[name=receive_notifications]': 'receiveNotificationsChangeHandler',
            'change input[name=receive_digests]': 'receiveDigestsChangeHandler',
        }, BaseSettingsView.prototype.events),

        templateHelpers: function () {
            return {
                FREQUENCY_NEVER: SettingsEmailNotifications.FREQUENCY_NEVER,
            };
        },

        receiveDigestsChangeHandler: function (ev) {
            this.updateDigestsDisplay($(ev.originalEvent.target).is(':checked'));
        },

        receiveNotificationsChangeHandler: function (ev) {
            this.updateNotificationsDisplay($(ev.originalEvent.target).is(':checked'));
        },

        onDomRefresh: function () {
            this.updateNotificationsDisplay(this.model.get('receive_notifications'));
            this.updateDigestsDisplay(this.shouldReceiveDigests());
        },

        shouldReceiveDigests: function () {
            var digestFrequency = this.model.get('digest_frequency');
            return digestFrequency && digestFrequency !== SettingsEmailNotifications.FREQUENCY_NEVER;
        },

        updateDigestsDisplay: function (receiveDigests) {
            var $digestElems = this.$el.find('[data-role=notification-digest]');
            if (receiveDigests) {
                $digestElems.show();
                this.setDefaultDigestFrequency();
            } else {
                $digestElems.hide();
            }
        },

        setDefaultDigestFrequency: function () {
            if (!this.$el.find('input[name=digest_frequency]:checked').val())
                this.$el.find('input[name=digest_frequency][value=daily]').attr('checked', 'checked');
        },

        updateNotificationsDisplay: function (receiveNotifications) {
            var $notificationElems = this.$el.find('[data-role=notification]');
            if (receiveNotifications)
                $notificationElems.removeClass('fieldset--hidden');
            else
                $notificationElems.addClass('fieldset--hidden');
        },

        getFormData: function () {
            var data = BaseSettingsView.prototype.getFormData.apply(this, arguments);

            // explicity set checkbox fields to true or false so that
            // the model is updated correctly
            data.receive_notifications = Boolean(data.receive_notifications);
            data.receive_welcome_emails = Boolean(data.receive_welcome_emails);
            data.replies_to_comments = Boolean(data.replies_to_comments);
            data.subscribe_thread_on_post = Boolean(data.subscribe_thread_on_post);

            // if user uncheck's receive_digests, set digest_frequency to never
            data.digest_frequency = data.receive_digests ? data.digest_frequency : SettingsEmailNotifications.FREQUENCY_NEVER;
            return data;
        },
    });

    return SettingsEmailView;
});

